import { Box } from "@chakra-ui/react";
import { FiPlus } from "react-icons/fi";
import { MAX_COLUMNS } from "./column-types";

export interface GhostAddColumnProps {
	columnCount: number;
	maxColumns?: number;
	onAdd: () => void;
}

/**
 * Trailing `+` cell that appends a new column. Rendered as the last cell of the
 * SpreadsheetGrid header row. Hidden when the column count reaches the ceiling.
 */
export const GhostAddColumn = ({
	onAdd,
	columnCount,
	maxColumns = MAX_COLUMNS,
}: GhostAddColumnProps) => {
	if (columnCount >= maxColumns) {
		return null;
	}

	const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			onAdd();
		}
	};

	return (
		<Box
			as="div"
			role="button"
			aria-label="Add column"
			tabIndex={0}
			onClick={onAdd}
			onKeyDown={handleKeyDown}
			display="flex"
			alignItems="center"
			justifyContent="center"
			h="12"
			minW="80px"
			border="2px dashed"
			borderColor="gray.300"
			bg="transparent"
			color="gray.400"
			cursor="pointer"
			transition="background-color 0.15s ease, color 0.15s ease"
			_hover={{ bg: "gray.50", color: "gray.600" }}
			_focus={{
				outline: "2px solid",
				outlineColor: "blue.400",
				outlineOffset: "1px",
			}}
		>
			<FiPlus size={18} />
		</Box>
	);
};

export default GhostAddColumn;
